import { DOCUMENT } from '@angular/common';
import { EventEmitter, Inject, Injectable } from '@angular/core';
import { AlertService } from './alert.service';
import { PlatformService } from './platform.service';

@Injectable({ providedIn: 'root' })
export class ClipboardService {
  isAllow = true;
  onPastImage = new EventEmitter<Blob>();

  constructor(
    private alertService: AlertService,
    private pt: PlatformService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    if (this.pt.isBrowser) {
      this.setIsAllow();
      this.autoDetectImage();
    }
  }

  async setIsAllow() {
    this.isAllow =
      (
        await (this.document.defaultView as Window).navigator.permissions.query(
          {
            name: 'clipboard-read' as any,
          },
        )
      ).state == 'granted';
  }

  async getImageFromClipboard() {
    if (await this.checkClipboardPermission()) {
      const items = await (
        this.document.defaultView as Window
      ).navigator.clipboard.read();
      for (const item of items) {
        for (const type of item.types) {
          //  console.log(type);
          if (type.startsWith('image/')) {
            return item.getType(type);
            /*
            .then((blob) => {
              return new Promise((resolve) => {
                const fileReader = new FileReader();
                fileReader.onload = () => {
                  const srcData = fileReader.result;
                  resolve(srcData);
                };
                fileReader.readAsDataURL(blob);
              });
            })*/
          }
        }
      }
    }

    return null;
  }

  private async getTextFromClipboard() {
    if (await this.checkClipboardPermission()) {
      return (
        this.document.defaultView as Window
      ).navigator.clipboard.readText();
    }
    return null;
  }

  private async checkClipboardPermission() {
    if (this.isAllow) return true;

    const permission = await (
      this.document.defaultView as Window
    ).navigator.permissions.query({
      name: 'clipboard-read' as any,
    });
    switch (permission.state) {
      case 'prompt':
        {
          this.alertService.error(
            'Please Allow Permission From Your Browser To Allow Use This Feature',
          );
          await (
            this.document.defaultView as Window
          ).navigator.clipboard.readText();
          return true;
        }
        break;
      case 'denied':
        {
          this.alertService.error(
            'Please Allow Permission From Your Browser To Allow Use This Feature',
          );
          return false;
        }
        break;
      default: {
        this.isAllow = true;
        return true;
      }
    }
  }

  async value() {
    const value = await this.getTextFromClipboard();
    return value;
  }
  copy(text: string) {
    if (text == '') return;
    (this.document.defaultView as Window).navigator.clipboard.writeText(text);
    this.alertService.suucess('Text copied successfully');
  }
  private async autoDetectImage() {
    this.document.onpaste = (event: ClipboardEvent) => {
      let index;
      const items = (
        event.clipboardData || (event as any).originalEvent.clipboardData
      ).items;
      for (index in items) {
        const item = items[index];
        if (item.kind === 'file') {
          const blob = item.getAsFile();
          this.onPastImage.emit(blob);
        }
      }
    };

    /*
  var ctrlDown = false,
    ctrlKey = 17,
    cmdKey = 91,
    vKey = 86,
    cKey = 67;
  
  
      document.onkeydown =async function (e) {
        console.log(e.keyCode);
    if (e.keyCode == ctrlKey || e.keyCode == cmdKey) ctrlDown = true;
  
    
    // if (ctrlDown && (e.keyCode == cKey)) {
      // console.log("Document catch Ctrl+C");
    // }
    if (ctrlDown && (e.keyCode == vKey)) {
      alert('Ctrl+V')
      let bloddata=  await clipboardService.getImageFromClipboard();
      window.onImageSelected(bloddata);
      // console.log("Document catch Ctrl+V");
    }
  }
  document.keyup = function (e) {
    if (e.keyCode == ctrlKey || e.keyCode == cmdKey) ctrlDown = false;
  };
  
  */
  }
}
